export const TAG_COLORS = ['magenta', 'red', 'volcano', 'orange', 'gold', 'lime', 'green', 'cyan', 'blue', 'geekblue', 'purple'] as const;

const colorIndex = new Map<string, number>(TAG_COLORS.map((c, i) => [c, i]));

export const compareByTag = (a: { color: string; name: string }, b: { color: string; name: string }) =>
  (colorIndex.get(a.color) ?? TAG_COLORS.length) - (colorIndex.get(b.color) ?? TAG_COLORS.length) || a.name.localeCompare(b.name);
